/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";

import Styled from "./style";

const FAQ = () => {
  const history = useHistory();
  const user = useSelector((state) => state.user);

  const publishJobAd = () => {
    if (user.id && user.type === "company") history.push("/publish-job");
    else history.push("/login");
  };

  return (
    <Styled>
      <div className="box">
        <h4 className="title is-4">Frequently Asked Questions</h4>
        <strong>How do I post my job?</strong>
        <br />
        <p>
          You need to have a company account to be able to post a job. Normal
          users can't post jobs. You can click{" "}
          <a onClick={publishJobAd}>here</a> to post a job.
        </p>
        <br />
        <strong>How much does it cost?</strong>
        <br />
        <p>Our platform is %100 free for both job seekers and companies!</p>
        <br />
        <strong>How can I edit my job post?</strong>
        <br />
        <p>
          Editing a job post is not possible at the moment. You can send a
          delete request by using our <Link to="/contact">contact form</Link>{" "}
          and create a new one.
        </p>
        <br />
        <strong>How can I delete my job post?</strong>
        <p>
          You can contact us from <Link to="/contact">here</Link> and send the
          delete request.
        </p>
        <hr />
        <p>
          If you have any questions or have any feedback, please contact us from{" "}
          <Link to="/contact">here</Link>.
        </p>
      </div>
    </Styled>
  );
};

export default FAQ;
